export default class Download {
    constructor(option) {
        this.apiManager = option.apiManager;
        this.options = {
            responseType: 'blob',
            method: 'post'
        };
    }
    /**
     * transform the data to be exported
     * @param params - the request parameter
     * @param params.columns - the column key
     * @param params.fileType - the export file type, such as excel
     * @param params.sheetName - the excel sheet name
     * @param params.data - the data to be exported, cplumns split by '|', rows split by '||'
     */
    exportWatchlist(params) {
        const formData = new FormData();
        if (!params.data || !params.columns) {
            const MISSING_DATA = 'Invalid arguments: Missing data in arguments';
            const MISSING_COLUMNS =
                'Invalid arguments: Missing columns in arguments';
            const msg = !params.data ? MISSING_DATA : MISSING_COLUMNS;
            throw new Error(msg);
        }
        ['columns', 'fileType', 'fileName', 'sheetName', 'data'].forEach(
            key => {
                if (typeof params[key] !== 'undefined') {
                    formData.append(key, params[key]);
                }
            }
        );

        return this.apiManager.exportWatchlist(
            {
                formData
            },
            this.options
        );
    }

    /**
     * export the file to ExcelRTD
     * @param params - the request parameter
     * @param params.symbols - the symbols to be watched in ExcelRTD
     * @param params.sheetName - the sheet name in excel
     */
    exportExcelRTD(params) {
        const formData = new FormData();
        if (!params.symbols) {
            const MISSING_SYMBOLS =
                'Invalid arguments: Missing symbols in arguments';
            throw new Error(MISSING_SYMBOLS);
        }
        ['symbols', 'sheetName'].forEach(key => {
            if (typeof params[key] !== 'undefined') {
                formData.append(key, params[key]);
            }
        });
        return this.apiManager.exportExcelRTD(
            {
                formData
            },
            this.options
        );
    }
}
